import { render } from "./OPINION_UPDATED_AND_MADE_PUBLIC_BY_MEMBER.vue?vue&type=template&id=f36a9b5a"
import script from "./OPINION_UPDATED_AND_MADE_PUBLIC_BY_MEMBER.vue?vue&type=script&lang=js"
export * from "./OPINION_UPDATED_AND_MADE_PUBLIC_BY_MEMBER.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__